module.exports = "/_next/static/images/nstrumenti-4d1388f4f915c06136e69458a2582f3e.svg";